import createIcon from '../../createIcon';

/**
 * @component @name List
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAxM0g1VjExSDNWMTNaTTMgMTdINVYxNUgzVjE3Wk0zIDlINVY3SDNWOVpNNyAxM0gyMVYxMUg3VjEzWk03IDE3SDIxVjE1SDdWMTdaTTcgN1Y5SDIxVjdIN1oiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const List = createIcon('List', [
  [
    'path',
    {
      d: 'M3 13H5V11H3V13ZM3 17H5V15H3V17ZM3 9H5V7H3V9ZM7 13H21V11H7V13ZM7 17H21V15H7V17ZM7 7V9H21V7H7Z',
      key: 'iq7yt8',
    },
  ],
]);

export default List;
